import React, {PropTypes} from 'react';
import {Button} from "elemental"
import {Link} from "react-router"
import "./Breadcrumbs.scss"
import _ from "lodash"

let defaultPath = [
   {
      title: "Kategorie",
      link:  "/collection/486f626279000000"
   },
   {
      title: "Subkategorie",
      link:  "/collection/486f626279000000"
   },
   {
      title: "Produkt",
      link:  "/product/100002"
   },
]

const Breadcrumbs = ({path = defaultPath}) => {
   let breadcrumb = []
   _.forEach(path, (segment, index) => {
      let isLast = (index == path.length - 1)
      breadcrumb.push(<li key={index}><Link to={segment.link}><Button type="link">{segment.title}</Button></Link></li>)
      if(!isLast){
         breadcrumb.push(<li key={`${index}-divider`}> <i className="icon-angle-right"></i></li>)
      }
   })

   return (
      <div className="breadcrumbs pt4 pb4">
         <ul className="breadcrumb-list">
            <li><Link to="/"><i className="icon-home-1"></i></Link></li>
            <li><i className="icon-angle-right"></i></li>
            {breadcrumb}
         </ul>
      </div>
   )
}

Breadcrumbs.propTypes = {
   path: PropTypes.array
}

export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js